import { api } from './client';

export interface FieldOrderItem {
  id: number;
  itemId: number | null;
  itemName: string;
  qty: string;
  rate: string;
}

export interface FieldOrder {
  id: number;
  orderNo: string;
  orderDate: string;
  salesperson: string;
  customerId: number | null;
  customerName: string;
  customerType: string | null;
  total: string;
  deliveryDate: string | null;
  status: string;
  enqId: number | null;
  items: FieldOrderItem[];
  customer?: { id: number; name: string };
}

export async function listFieldOrders(filter: {
  status?: string;
  salesperson?: string;
  search?: string;
} = {}): Promise<FieldOrder[]> {
  const r = await api.get<FieldOrder[]>('/field-orders', { params: filter });
  return r.data;
}

export async function getFieldOrder(id: number): Promise<FieldOrder> {
  const r = await api.get<FieldOrder>(`/field-orders/${id}`);
  return r.data;
}

export async function createFieldOrder(payload: {
  orderDate?: string;
  salesperson: string;
  customerId?: number;
  customerName: string;
  customerType?: string;
  deliveryDate?: string;
  items: Array<{ itemId?: number; itemName: string; qty: number; rate?: number }>;
}): Promise<FieldOrder> {
  const r = await api.post<FieldOrder>('/field-orders', payload);
  return r.data;
}

export async function approveFieldOrder(
  id: number,
): Promise<{ fieldOrder: FieldOrder; enquiry: { id: number; enqNo: string } }> {
  const r = await api.post(`/field-orders/${id}/approve`);
  return r.data;
}

export async function rejectFieldOrder(id: number, reason: string): Promise<FieldOrder> {
  const r = await api.post<FieldOrder>(`/field-orders/${id}/reject`, { reason });
  return r.data;
}
